var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobot1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 128,
    viewBox: "0 0 133 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.002 60.3587C131.343 45.7449 136.492 30.5355 130.5 26.394C124.509 22.247 109.652 30.7396 97.3054 45.3533C84.9647 59.9671 79.8158 75.1765 85.8072 79.3235C91.7986 83.465 106.661 74.978 119.002 60.3587Z",
    fill: "url(#paint0_linear_66_1510)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.274 48.7449C127.461 48.4305 127.637 48.1162 127.808 47.8074C125.098 46.6769 122.521 45.3258 120.203 43.9141C115.847 41.2615 111.805 38.1402 108.457 34.5006C108.418 34.462 108.385 34.4234 108.347 34.3848C108.044 34.6329 107.741 34.8811 107.444 35.1403C111.089 39.0115 115.384 42.4858 120.159 45.2045C122.383 46.4784 124.779 47.6971 127.274 48.7449Z",
    fill: "#9D9CA9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.345 61.1201C94.453 56.1569 101.193 54.0834 105.401 56.4878C109.602 58.8921 109.679 64.8645 105.571 69.8277C101.463 74.7908 94.7229 76.8643 90.5157 74.46C86.314 72.0556 86.2369 66.0832 90.345 61.1201Z",
    fill: "url(#paint1_linear_66_1510)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.774 71.9662C88.3167 68.9465 89.7421 63.7099 93.9575 60.2699C98.173 56.8299 103.582 56.4892 106.039 59.5089C108.497 62.5286 107.071 67.7652 102.856 71.2052C98.6404 74.6452 93.2312 74.9859 90.774 71.9662Z",
    fill: "url(#paint2_radial_66_1510)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5991 73.4001C5.44657 62.7789 -2.90726 50.007 0.936489 44.8729C4.78024 39.7388 19.3678 44.1836 33.5203 54.7993C47.6727 65.4149 56.0266 78.1924 52.1828 83.3265C48.3391 88.4606 33.7515 84.0158 19.5991 73.4001Z",
    fill: "url(#paint3_linear_66_1510)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62607 64.6152C9.38927 64.367 9.15798 64.1244 8.9322 63.8762C10.8706 62.2329 12.6383 60.4186 14.1802 58.6097C17.0713 55.2072 19.5769 51.4407 21.3666 47.3599C21.3886 47.3158 21.4051 47.2717 21.4271 47.2275C21.741 47.3875 22.0604 47.5474 22.3798 47.7128C20.4029 52.0749 17.7816 56.2164 14.5657 59.7789C13.0623 61.4443 11.4048 63.0987 9.62607 64.6152Z",
    fill: "#9D9CA9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5262 67.6766C38.7903 64.0535 32.6502 63.6674 29.8197 66.8108C26.9892 69.9541 28.5311 75.4412 33.2725 79.0643C38.0083 82.6874 44.1484 83.0734 46.9789 79.9301C49.8094 76.7868 48.262 71.2997 43.5262 67.6766Z",
    fill: "url(#paint4_linear_66_1510)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3476 68.9828C38.4157 65.9773 33.3219 65.6519 30.976 68.2604C28.6246 70.8688 29.9077 75.4239 33.8396 78.4294C37.7714 81.4348 42.8652 81.7602 45.2111 79.1518C47.5625 76.5433 46.2795 71.9883 42.3476 68.9828Z",
    fill: "url(#paint5_radial_66_1510)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6817 57.6186L92.4153 72.1607C96.4077 87.7065 87.8557 103.346 73.3122 107.09C58.7742 110.835 43.7517 101.267 39.7592 85.7212L35.9595 70.9254C35.921 70.567 35.9926 70.1864 36.1688 69.7894C36.1908 69.7287 36.2184 69.6736 36.2514 69.6184C36.5983 68.9291 37.2426 68.1957 38.1402 67.4291C38.2889 67.3023 38.4431 67.1755 38.6083 67.0486H38.6138C38.7735 66.9218 38.9497 66.7949 39.1204 66.6626C39.2086 66.5964 39.3022 66.5302 39.3958 66.4641C39.4894 66.3979 39.583 66.3317 39.6821 66.2711C39.7757 66.2049 39.8749 66.1387 39.974 66.0725C40.1722 65.9402 40.376 65.8078 40.5852 65.6755C41.5324 65.0799 42.6062 64.4788 43.7957 63.8832C46.439 62.5542 49.6329 61.2362 53.2069 60.0285C53.5648 59.9072 53.9282 59.7858 54.2917 59.67C55.0186 59.4329 55.7675 59.2013 56.5219 58.9752L64.8317 56.8355C77.5359 54.0892 87.8391 54.3374 88.6817 57.6186Z",
    fill: "url(#paint6_linear_66_1510)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M86.6938 58.7217C87.5473 62.0525 77.3818 67.5451 63.9837 70.9918C50.5857 74.4439 39.0379 74.5377 38.1788 71.2123C37.3253 67.8815 47.4908 62.3889 60.8889 58.9423C74.287 55.4901 85.8402 55.3964 86.6938 58.7217Z",
    fill: "url(#paint7_linear_66_1510)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1013 58.0932C70.8947 55.3139 80.2838 55.5675 81.0768 58.6612C81.8697 61.755 73.7637 66.5141 62.9759 69.288C52.1825 72.0673 42.7934 71.8137 42.0005 68.7199C41.2075 65.6318 49.3135 60.8726 60.1013 58.0932Z",
    fill: "url(#paint8_linear_66_1510)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4153 68.1943C44.7564 65.6281 51.4813 61.6788 60.4357 59.3733C69.3901 57.0679 77.1831 57.2793 77.842 59.8456C78.5008 62.4118 71.7759 66.3611 62.8216 68.6665C53.8672 70.972 46.0741 70.7606 45.4153 68.1943Z",
    fill: "url(#paint9_radial_66_1510)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2978 86.1458C77.2604 93.1218 74.6612 100.908 68.4881 103.539C62.315 106.169 54.9028 102.651 51.9402 95.6806C48.9775 88.7046 51.5767 80.9179 57.7498 78.2874C63.923 75.6514 71.3296 79.1698 74.2978 86.1458Z",
    fill: "url(#paint10_linear_66_1510)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1507 61.192C84.7112 61.8206 84.2541 68.0026 86.1154 75.2598C87.6793 81.348 90.3061 85.9858 92.5529 86.9508C92.6024 86.7468 92.652 86.5373 92.7015 86.3277C90.8678 85.4674 88.3346 81.3204 86.7377 75.0999C84.8433 67.7323 85.5041 62.2784 87.3049 61.8151C88.1089 61.6111 89.1827 62.3721 90.3006 63.9272L89.9316 62.4879C88.9624 61.4567 87.9987 60.9714 87.1507 61.192Z",
    fill: "#9D9CA9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2963 73.1139C94.7776 78.8712 94.7501 83.8564 93.2467 84.248C91.7378 84.634 89.3204 80.283 87.839 74.5202C86.3577 68.7629 86.3852 63.7776 87.8886 63.3861C89.3974 63.0001 91.8204 67.3566 93.2963 73.1139Z",
    fill: "url(#paint11_linear_66_1510)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6683 73.2751C93.8963 78.0563 93.8743 82.1923 92.6242 82.5121C91.3742 82.832 89.3642 79.2199 88.1362 74.4387C86.9082 69.6575 86.9302 65.5215 88.1802 65.2017C89.4358 64.8873 91.4458 68.4994 92.6683 73.2751Z",
    fill: "url(#paint12_radial_66_1510)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M89.0562 59.0676C82.839 63.9536 61.7755 69.7495 53.6034 68.5859C44.9192 67.3506 57.2049 60.3029 57.2049 60.3029L67.5411 56.2772C78.9733 54.1375 87.8998 54.5732 88.6818 57.6173L89.0562 59.0676Z",
    fill: "#231F20"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9979 44.5814C24.6432 26.929 38.7461 14.9237 57.1719 13.5064C75.5977 12.0836 91.3692 21.7894 92.7238 39.4418C94.0785 57.0941 79.4084 61.7209 60.9826 63.1382C42.5568 64.5609 27.3525 62.2338 25.9979 44.5814Z",
    fill: "url(#paint13_linear_66_1510)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5444 48.3196C86.3747 48.4851 84.8218 43.6267 84.4639 38.9723C84.1059 34.3125 84.8989 29.2721 87.0686 29.1066C89.2383 28.9412 90.7912 33.7996 91.1492 38.454C91.5071 43.1138 90.7141 48.1542 88.5444 48.3196ZM87.1292 29.8897C85.9177 29.9835 84.8494 33.7114 85.2459 38.9117C85.6479 44.112 87.2724 47.6303 88.4839 47.5366C89.6954 47.4428 90.7637 43.7149 90.3672 38.5146C89.9707 33.3143 88.3407 29.796 87.1292 29.8897Z",
    fill: "#9D9CA9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5624 37.088C80.5921 50.4885 70.399 59.4388 57.0561 60.47C43.7131 61.4957 32.2754 54.2109 31.2457 40.8159C30.2159 27.4153 41.0698 27.0513 54.4073 26.0201C67.7558 24.9888 78.5326 23.6874 79.5624 37.088Z",
    fill: "#E2E3E7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1604 37.2142C80.1736 50.3831 70.1513 59.1404 57.0341 60.1496C43.9168 61.1587 32.6774 54.0449 31.6642 40.8704C30.6509 27.7014 41.3176 27.3375 54.4348 26.3283C67.552 25.3191 78.1471 24.0397 79.1604 37.2142Z",
    fill: "url(#paint14_linear_66_1510)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0284 17.8686C75.0304 21.4807 72.0458 25.9917 71.7153 31.7104C71.6768 32.3776 70.658 32.1736 70.6966 31.5118C71.027 25.7104 74.0282 21.0671 78.0647 17.3447C78.3896 17.5102 78.709 17.6866 79.0284 17.8686Z",
    fill: "#9D9CA9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1218 34.9136C35.1999 31.2188 33.647 27.2538 33.6305 23.4763C34.0105 23.0958 34.4069 22.7263 34.8089 22.3623C34.44 26.3825 35.9433 30.5515 38.0414 34.5883C38.3498 35.1728 37.4247 35.5037 37.1218 34.9136Z",
    fill: "#9D9CA9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2301 37.5496C79.1938 50.0954 69.6395 58.3012 57.1501 59.2662C44.6607 60.2313 33.9609 53.5807 32.9973 41.0404C32.0336 28.4946 42.1936 28.1527 54.6831 27.1876C67.1725 26.2225 77.2665 25.0038 78.2301 37.5496Z",
    fill: "url(#paint15_radial_66_1510)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9471 46.8975C60.2115 50.3441 57.6398 53.3496 54.198 53.6143C50.7563 53.879 47.7551 51.3037 47.4907 47.857L59.9471 46.8975Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8207 46.9746C60.0795 50.3496 57.5574 53.2944 54.1873 53.5536C50.8171 53.8128 47.8765 51.2871 47.6176 47.9121L59.8207 46.9746Z",
    fill: "#061417"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6995 47.0459C59.9528 50.3492 57.4857 53.2333 54.1872 53.487C50.8886 53.7407 48.0085 51.2701 47.7552 47.9668L59.6995 47.0459Z",
    fill: "#0C282D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5725 47.124C59.8203 50.3556 57.4083 53.1791 54.1758 53.4273C50.9489 53.6754 48.1294 51.26 47.8816 48.0229L59.5725 47.124Z",
    fill: "#133C44"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4517 47.1953C59.694 50.3552 57.3316 53.118 54.1762 53.3607C51.0208 53.6033 48.2619 51.2375 48.0196 48.0777L59.4517 47.1953Z",
    fill: "#19505B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3248 47.2725C59.5616 50.3607 57.2542 53.0573 54.1704 53.3C51.0866 53.5371 48.3938 51.2265 48.1515 48.1383L59.3248 47.2725Z",
    fill: "#1F6472"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2035 47.3438C59.4348 50.3603 57.1825 52.9963 54.1648 53.2279C51.1526 53.4595 48.5203 51.204 48.289 48.182L59.2035 47.3438Z",
    fill: "#257888"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M59.077 47.415C59.3028 50.3654 57.1001 52.9352 54.1595 53.1613C51.2188 53.3874 48.6472 51.1815 48.4214 48.2367L59.077 47.415Z",
    fill: "#2B8C9F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9558 47.4932C59.1761 50.3718 57.0285 52.881 54.1539 53.1016C51.2794 53.3221 48.7738 51.1714 48.5535 48.2928L58.9558 47.4932Z",
    fill: "#31A0B6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8293 47.5645C59.0441 50.3714 56.9515 52.8199 54.1485 53.035C51.3456 53.25 48.9006 51.1545 48.6858 48.3475L58.8293 47.5645Z",
    fill: "#38B4CD"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7081 47.6416C58.9174 50.3769 56.8743 52.7647 54.143 52.9743C51.4116 53.1838 49.0271 51.1379 48.8179 48.4026L58.7081 47.6416Z",
    fill: "#3EC8E3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5816 47.7129C58.7853 50.3765 56.7974 52.6981 54.1376 52.9077C51.4778 53.1117 49.1594 51.1209 48.9502 48.4574L58.5816 47.7129Z",
    fill: "#44DCFA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M56.291 42.9991C55.9661 38.7639 59.127 35.0691 63.3562 34.7437C67.5855 34.4183 71.275 37.5837 71.5999 41.819L56.291 42.9991Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4398 42.9108C56.1204 38.7638 59.2207 35.1462 63.3563 34.8264C67.4975 34.5065 71.1099 37.6113 71.4293 41.7528L56.4398 42.9108Z",
    fill: "#061417"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M56.594 42.8177C56.2801 38.7589 59.3143 35.2185 63.3673 34.9042C67.4203 34.5898 70.9557 37.6284 71.2696 41.6872L56.594 42.8177Z",
    fill: "#0C282D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7479 42.7229C56.4451 38.7523 59.4077 35.2836 63.3726 34.9803C67.3375 34.677 70.8013 37.6439 71.1042 41.6144L56.7479 42.7229Z",
    fill: "#133C44"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8969 42.6346C56.5996 38.7523 59.5016 35.3608 63.3784 35.063C67.2552 34.7652 70.6419 37.6714 70.9393 41.5537L56.8969 42.6346Z",
    fill: "#19505B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0509 42.5414C56.759 38.7474 59.5951 35.4331 63.3837 35.1408C67.1724 34.8485 70.482 37.6886 70.7739 41.4826L57.0509 42.5414Z",
    fill: "#1F6472"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1994 42.4535C56.913 38.7476 59.683 35.505 63.389 35.2238C67.0951 34.9425 70.3276 37.7109 70.6085 41.4222L57.1994 42.4535Z",
    fill: "#257888"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3538 42.36C57.073 38.7369 59.7823 35.577 63.3948 35.3013C67.0127 35.02 70.1681 37.7332 70.4435 41.3508L57.3538 42.36Z",
    fill: "#2B8C9F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M57.508 42.2711C57.2382 38.7362 59.876 35.6535 63.4058 35.3833C66.9357 35.1131 70.014 37.7546 70.2838 41.2895L57.508 42.2711Z",
    fill: "#31A0B6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6565 42.1766C57.3922 38.73 59.9639 35.7245 63.4056 35.4543C66.8474 35.1896 69.8486 37.7649 70.1184 41.2115L57.6565 42.1766Z",
    fill: "#38B4CD"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M57.811 42.0893C57.5522 38.7309 60.0633 35.7971 63.417 35.5379C66.7706 35.2787 69.7002 37.7934 69.959 41.1518L57.811 42.0893Z",
    fill: "#3EC8E3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9594 41.9952C57.7061 38.725 60.1511 35.8684 63.4167 35.6147C66.6822 35.3611 69.5347 37.8096 69.788 41.0797L57.9594 41.9952Z",
    fill: "#44DCFA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8825 44.5707C35.5576 40.3355 38.2614 36.6793 41.9179 36.398C45.5744 36.1168 48.8069 39.3208 49.1318 43.5505L35.8825 44.5707Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0146 44.4821C35.6952 40.3351 38.3439 36.7506 41.9234 36.4749C45.5083 36.1991 48.6692 39.337 48.9886 43.4785L36.0146 44.4821Z",
    fill: "#061417"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1415 44.3948C35.8276 40.3361 38.4213 36.8288 41.9292 36.5585C45.437 36.2883 48.5318 39.36 48.8457 43.4187L36.1415 44.3948Z",
    fill: "#0C282D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2735 44.3062C35.9706 40.3357 38.5037 36.9001 41.9345 36.6354C45.3652 36.3707 48.394 39.3761 48.7023 43.3467L36.2735 44.3062Z",
    fill: "#133C44"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4056 44.2131C36.1082 40.3308 38.5863 36.9724 41.9455 36.7132C45.3046 36.454 48.2673 39.3933 48.5646 43.2756L36.4056 44.2131Z",
    fill: "#19505B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M36.532 44.1238C36.2402 40.3298 38.6632 37.0486 41.9452 36.7949C45.2273 36.5412 48.1238 39.4143 48.4157 43.2084L36.532 44.1238Z",
    fill: "#1F6472"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6645 44.0362C36.3782 40.3304 38.7461 37.1208 41.9511 36.8727C45.156 36.6245 47.9865 39.4315 48.2729 43.1373L36.6645 44.0362Z",
    fill: "#257888"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7967 43.9479C36.5159 40.3248 38.8288 37.198 41.9621 36.9554C45.09 36.7127 47.8544 39.4535 48.1353 43.0766L36.7967 43.9479Z",
    fill: "#2B8C9F"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9288 43.8538C36.6589 40.3189 38.9112 37.2638 41.9675 37.0322C45.0238 36.7951 47.7166 39.4697 47.9919 43.0046L36.9288 43.8538Z",
    fill: "#31A0B6"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0556 43.7662C36.7913 40.3195 38.9885 37.3416 41.9677 37.11C44.9469 36.8784 47.5736 39.4868 47.8434 42.9335L37.0556 43.7662Z",
    fill: "#38B4CD"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1877 43.6769C36.9289 40.3185 39.0766 37.4123 41.9787 37.1917C44.8808 36.9656 47.4469 39.5079 47.7057 42.8663L37.1877 43.6769Z",
    fill: "#3EC8E3"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3197 43.5893C37.0664 40.3191 39.1589 37.4901 41.9839 37.2695C44.8144 37.0489 47.309 39.525 47.5568 42.8007L37.3197 43.5893Z",
    fill: "#44DCFA"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M76.6442 47.2119C73.4722 54.21 66.0601 58.5831 57.1501 59.2669C48.5264 59.9342 40.7563 56.9673 36.4555 50.9398C37.656 51.6291 43.0196 52.7927 48.2786 52.881C61.2692 53.1015 74.7003 48.3645 76.6442 47.2119Z",
    fill: "url(#paint16_linear_66_1510)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M74.0391 34.4453C73.4113 32.9012 72.3926 31.0924 70.9058 30.4968C70.0467 30.1494 68.8407 30.006 67.5962 29.9619C68.1634 31.5501 68.67 33.1549 69.1381 34.7762C70.7736 34.6769 72.4091 34.5611 74.0391 34.4453Z",
    fill: "url(#paint17_linear_66_1510)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M69.3145 35.3937C69.4962 36.0334 69.6669 36.6731 69.8376 37.3183L74.8323 36.9322C74.8323 36.9322 74.6561 36.1161 74.2761 35.0518C72.6185 35.1731 70.9665 35.2834 69.3145 35.3937Z",
    fill: "url(#paint18_linear_66_1510)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M68.2462 34.8364C68.3508 34.8309 68.4554 34.8199 68.5546 34.8143C68.081 33.1765 67.5578 31.5552 66.9796 29.9504C64.3914 29.9394 61.8142 30.3199 61.8142 30.3199L62.453 35.2004C64.3859 35.1397 66.3188 34.9577 68.2462 34.8364Z",
    fill: "url(#paint19_linear_66_1510)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_66_1510",
    x1: 96.3309,
    y1: 38.7695,
    x2: 115.321,
    y2: 58.8759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9EAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_66_1510",
    x1: 102.319,
    y1: 59.0937,
    x2: 92.6657,
    y2: 74.0769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9EAB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_66_1510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.3295 65.7195) rotate(-110.915) scale(7.12674 7.32702)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#4CAAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_66_1510",
    x1: 33.6009,
    y1: 48.4393,
    x2: 21.6546,
    y2: 71.3308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9EAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_66_1510",
    x1: 32.8814,
    y1: 68.7663,
    x2: 45.3061,
    y2: 79.7213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9EAB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_66_1510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.0197 73.7415) rotate(-168.427) scale(8.12669 5.53163)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#4CAAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_66_1510",
    x1: 46.7662,
    y1: 70.4834,
    x2: 92.3615,
    y2: 89.3363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9EAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_66_1510",
    x1: 64.0547,
    y1: 72.0565,
    x2: 59.8928,
    y2: 53.8672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_66_1510",
    x1: 74.5638,
    y1: 60.337,
    x2: 44.5182,
    y2: 68.0507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9EAB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_66_1510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.5383 63.9991) rotate(-64.9808) scale(5.96399 10.1261)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#4CAAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_66_1510",
    x1: 65.9499,
    y1: 101.949,
    x2: 58.3821,
    y2: 72.5552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9EAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_66_1510",
    x1: 92.3533,
    y1: 80.7692,
    x2: 88.2259,
    y2: 64.7383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9EAB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_66_1510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.3739 73.8999) rotate(-147.213) scale(3.62338 5.7127)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#4CAAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_66_1510",
    x1: 57.7511,
    y1: 21.0875,
    x2: 61.3816,
    y2: 68.2171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9EAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_66_1510",
    x1: 56.8993,
    y1: 58.3886,
    x2: 54.6195,
    y2: 28.7938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9EAB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_66_1510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.1947 31.4852) rotate(-4.40812) scale(29.6173 29.7415)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27213B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_66_1510",
    x1: 56.4321,
    y1: 47.5593,
    x2: 57.1817,
    y2: 57.2908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_66_1510",
    x1: 70.6408,
    y1: 29.8866,
    x2: 71.3966,
    y2: 39.6976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_66_1510",
    x1: 71.5844,
    y1: 29.8138,
    x2: 72.3402,
    y2: 39.6253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_66_1510",
    x1: 65.0128,
    y1: 30.3199,
    x2: 65.7686,
    y2: 40.1311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot1);
export default __webpack_public_path__ + "static/media/robot1.d4ba3481f06b2046bab2cd398d772265.svg";
export { ForwardRef as ReactComponent };